<template>
  <layout>
    <template v-slot:title>{{ title }}</template>
    <template-details v-if="currentTemplates.length === 1"></template-details>
    <template-list v-else></template-list>
  </layout>
</template>
<script>
import currentTempates from "@/mixins/currentTemplates";
import TemplateList from "./List.vue";
import TemplateDetails from "./Details.vue";

export default {
  components: { TemplateList, TemplateDetails },
  mixins: [currentTempates],
  computed: {
    title: function() {
      if (this.currentTemplates.length === 1) {
        return "Current Template";
      }

      return "Templates";
    },
  },
};
</script>
